/**
 * Configuration for the pre-authentication maintenance mode check.
 *
 * MAINTENANCE_STATUS_URL
 *   Read from REACT_APP_MAINTENANCE_STATUS_URL environment variable.
 *   Must be set per environment (Dev / Stage / Prod) independently.
 *   If absent or empty the JSON-based maintenance check is skipped entirely
 *   and the app falls through to the colleague's REACT_APP_MAINTENANCE_MODE
 *   mechanism.
 *
 *   Expected JSON response: { "maintenanceMode": true | false }
 *
 * MAINTENANCE_CHECK_TIMEOUT_MS – Max wait before failing open and continuing normal flow
 */
export const MAINTENANCE_STATUS_URL: string | undefined =
  process.env.REACT_APP_MAINTENANCE_STATUS_URL || undefined;

export const MAINTENANCE_CHECK_TIMEOUT_MS = 5000; // 5 seconds
